
export default {
  init() {
    var mapInitialized = false;
    $('.open-map').on('click', function(e) {
      e.preventDefault();
      $(this).addClass('focus');
      if (!mapInitialized) {
        initMap();
        mapInitialized = true;
      }
      $('#map-tab').show().siblings('.tab-content').hide().parents('.tab-nav').find('ul li a').removeClass('current');
    });

    $('#next-departures .stop a').on('click', function(e) {
      e.preventDefault();
      $('.departures-container').addClass("detail-view");
      var id = $(this).attr("href");
      $('.stop-detail'+id).show().siblings('.stop-detail').hide();
      $('#next-departures').animate({
        height: $('.departures-container .stop-details').outerHeight()
      });
    });

    $('#next-departures .back').on('click', function(e) {
      e.preventDefault();
      $('.departures-container').removeClass("detail-view");
      $('#next-departures').animate({
        height: $('.stops-list').outerHeight() + 40
      });
    });

    $('#trip-planner').on('click', 'button.transfer-button', function() {
      $(this).toggleClass('open');
      $(this).parents('tr').next('tr.transfer-row').slideToggle().siblings('.transfer-row').slideUp();
    });

    $('#trip-planner form').on('submit', function(e) {
      e.preventDefault();

      var stop = $('#trip-planner form [name="departure_point"] option:selected').val();
      var dest = $('#trip-planner form [name="arrival_point"] option:selected').val();
      var date = $('#trip-planner form [name="date"]').val();
      var time = $('#trip-planner form [name="time"] option:selected').val();
      var offset = 0;
      $("#load-back").attr("data-offset", 10);
      $("#load-forward").attr("data-offset", 10);

      $.ajax({
        url: ajaxurl,
        method: 'POST',
        data: {
          action: 'search_departures',
          stop: stop,
          dest: dest,
          date: date,
          offset: offset,
          count: 10,
          time: time,
        },
        success: function(data) {
          var content = "";
          var d = JSON.parse(data);
          $('.results table tbody').html("");
          if (d.routes.length > 0) {
            d.routes.forEach(function(item) {
              content +=
                "<tr><td>" +
                item.departure_time +
                "</td><td>to " +
                item.arrival_dock +
                (item.transfer_dock !== false ? " <button type='button' class='transfer-button'><i class='fas fa-chevron-down'></i><span class='sr-only'>See Transfer</span></button>" : "") +
                "</td><td>Arrives " +
                item.arrival_time +
                "</td></tr>";
              if (item.transfer_dock !== false) {
                content += 
                  "<tr class='transfer-row'><td colspan='3'>" +
                  "<div class='row'>"+
                  "<span class='dock'>"+item.departure_dock+"</span>"  +
                  "<span class='time'>Depart "+item.departure_time+"</span>"+
                  "</div>" +
                  "<div class='row'>"+
                  "<span class='dock'>"+item.transfer_dock.post_title+"</span>"+
                  "<span class='time'>Arrive "+item.transfer_time+"</span>"+
                  "</div>"+
                  "<div class='transfer'>Transfer</div>"+
                  "<div class='row'>"+
                  "<span class='dock'>"+item.transfer_dock.post_title+"</span>"+
                  "<span class='time'>Depart "+item.transfer_departure+"</span>"+
                  "</div>"+
                  "<div class='row'>"+
                  "<span class='dock'>"+item.arrival_dock+"</span>"+
                  "<span class='time'>Arrive "+item.arrival_time+"</span>"+
                  "</div>"+
                  "</td></tr>";
              }
            });
          } else {
            content += "<tr><td colspan='3' style='text-align: center'>No departures for this day.</td></tr>";
          }
          if (d.total > 10) {
            $('.results #load-forward').show();
          }  else {
            $('.results .load-forward').hide();
          }
          $('.results table tbody').append(content);
          $('.results table').show();
        }
      });
    });

    $("#trip-planner .results .load").on("click", function(e) {
      e.preventDefault();

      var stop = $(
        '#trip-planner form [name="departure_point"] option:selected'
      ).val();
      var dest = $(
        '#trip-planner form [name="arrival_point"] option:selected'
      ).val();
      var date = $('#trip-planner form [name="date"]').val();
      var time = $('#trip-planner form [name="time"]').val();
      var offset = parseInt($(this).attr('data-offset'));

      $.ajax({
        url: ajaxurl,
        method: "POST",
        data: {
          action: "search_departures",
          stop: stop,
          dest: dest,
          date: date,
          offset: offset,
          count: 10,
          time: time
        },
        success: function(data) {
          var content = "";
          var d = JSON.parse(data);
          $(".results table tbody").html("");
          if (d.routes.length > 0) {
            d.routes.forEach(function(item) {
              content +=
                "<tr><td>" +
                item.departure_time +
                "</td><td>to " +
                item.arrival_dock +
                (item.transfer_dock !== false ? "<button type='button' class='transfer-button'><i class='fas fa-chevron-down'></i><span class='sr-only'>See Transfer</span></button>" : "") +
                "</td><td>Arrives " +
                item.arrival_time +
                "</td></tr>";
              if (item.transfer_dock !== false) {
                content += 
                  "<tr class='transfer-row'><td colspan='3'>" +
                  "<div class='row'>"+
                  "<span class='dock'>"+item.departure_dock+"</span>"  +
                  "<span class='time'>Depart "+item.departure_time+"</span>"+
                  "</div>" +
                  "<div class='row'>"+
                  "<span class='dock'>"+item.transfer_dock.post_title+"</span>"+
                  "<span class='time'>Arrive "+item.transfer_time+"</span>"+
                  "</div>"+
                  "<div class='transfer'>Transfer</div>"+
                  "<div class='row'>"+
                  "<span class='dock'>"+item.transfer_dock.post_title+"</span>"+
                  "<span class='time'>Depart "+item.transfer_departure+"</span>"+
                  "</div>"+
                  "<div class='row'>"+
                  "<span class='dock'>"+item.arrival_name+"</span>"+
                  "<span class='time'>Arrive "+item.arrival_time+"</span>"+
                  "</div>"+
                  "</td></tr>";
              }
            });
            var nextOffset = offset+10;
            var prevOffset = offset-10;
            $('#load-back').attr('data-offset', prevOffset);
            $('#load-forward').attr('data-offset', nextOffset);
            if (d.total > nextOffset) {
              $(".results #load-forward").show();
            } else {
              $(".results #load-forward").hide();
            }
            if (prevOffset < 0) {
              $('.results #load-back').hide();
            } else {
              $('.results #load-back').show();
            }
          } else {
            $('.results #load-back').show();
            $('.results #load-forward').hide();
            content = "<tr><td colspan='3' style='text-align: center'>No further departures for this day.</td></tr>";
          }
          $(".results table tbody").html(content);
          $(".results table").show();
        }
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    $(window).trigger('resize');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js